import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import Contact from "@/components/landing/Contact";
import FAQ from "@/components/landing/FAQ";
import useReveal from "@/hooks/useReveal";
import useSEO from "@/hooks/useSEO";

const routes = [
    ["General", "workwithdilip1@gmail.com", "Product questions, waitlist updates, feedback."],
    ["Press", "workwithdilip1@gmail.com", "Launch notes, founder interviews, media kit requests."],
    ["Safety", "workwithdilip1@gmail.com", "Reports, verification issues, urgent trust concerns."],
];

export default function Support() {
    useReveal();
    useSEO({
        title: "Support",
        description: "Need help? Contact the LÜVYN support team and find answers to common questions.",
        canonical: "/support",
    });

    return (
        <div className="relative min-h-screen overflow-x-hidden" data-testid="support-page">
            <div className="grain" />
            <Header />
            <main id="top">
                <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28">
                    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
                        <div className="reveal in grid lg:grid-cols-[1.1fr_0.9fr] gap-12 items-end">
                            <div>
                                <div className="stamp stamp-large mb-7">
                                    Letters to the editor
                                </div>
                                <h1 className="font-display text-[17vw] sm:text-[12vw] lg:text-[10rem] leading-[0.82] tracking-tighter">
                                    Need a{" "}
                                    <span className="font-italic-serif text-[var(--hot)]">
                                        human?
                                    </span>
                                    <br />
                                    Start here.
                                </h1>
                            </div>
                            <p className="text-lg leading-relaxed text-[var(--ink-soft)] max-w-xl">
                                Support should not feel like shouting into a void.
                                Pick the right mailbox, or use the form below and
                                we will route the note.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="relative py-20 bg-[var(--paper-2)] border-y-2 border-[var(--ink)]">
                    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-3 gap-5">
                        {routes.map(([label, email, copy]) => (
                            <article
                                key={email}
                                className="reveal bg-[var(--paper)] border-2 border-[var(--ink)] p-7"
                            >
                                <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--hot)]">
                                    {label}
                                </div>
                                <a
                                    href={`mailto:${email}`}
                                    className="mt-8 block font-display text-3xl hover:text-[var(--hot)] transition"
                                >
                                    {email}
                                </a>
                                <p className="mt-4 text-sm leading-relaxed text-[var(--ink-soft)]">
                                    {copy}
                                </p>
                            </article>
                        ))}
                    </div>
                </section>

                <FAQ />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}
